import type { VgsFormState } from "@/hooks/useVgsCollect";

export type VgsCardMetadata = {
  bin?: string;
  last_four?: string;
  card_network?: string;
};

// Map VGS Collect card-number field state to the create-payment-method wire
// fields. Each field is omitted when VGS did not supply it. card_network is the
// client hint; the server derives the authoritative brand from bin.
export function vgsCardMetadata(fieldState: VgsFormState): VgsCardMetadata {
  const card = fieldState.card_number;
  return {
    ...(card?.bin ? { bin: card.bin } : {}),
    ...(card?.last4 ? { last_four: card.last4 } : {}),
    ...(card?.cardType ? { card_network: card.cardType } : {}),
  };
}
